// eventually load breakpoints from bui design-tokens and use https://www.npmjs.com/package/@rollup/plugin-json
export const breakpoints = [
  {
    name: 'XS',
    width: 360,
  },
  {
    name: 'S',
    width: 560,
  },
  {
    name: 'M',
    width: 760,
  },
  {
    name: 'L',
    width: 960,
  },
  {
    name: 'XL',
    width: 1160,
  },
  {
    name: 'XXL',
    width: 1360,
  },
  {
    name: 'XXXL',
    width: 1660,
  },
  {
    name: 'fullHD',
    width: 1920,
  },
];

const pubsub = {};
/*! Js Pub/Sub
 * http://anasnakawa.com/
 * Copyright (c) Anas Nakawa
 * inspired by Ben Alman's one <https://gist.github.com/cowboy/661855>
 * MIT License
 */
(function (p) {
  const e = (p.e = {});

  p.emit = function (name, data) {
    (e[name] = e[name] || new Event(name)).data = data;
    dispatchEvent(e[name]);
  };

  p.on = function (name, handler) {
    addEventListener(name, handler);
  };

  p.off = function (name, handler) {
    removeEventListener(name, handler);
  };
})(pubsub);

const emitChangeWithDebounced = (() => {
  let timer;
  return () => {
    clearTimeout(timer);
    timer = setTimeout(() => pubsub.emit('change:width'), 100);
  };
})();

class MediaQuery {
  constructor() {
    this.breakpoints = breakpoints.reduce((agg, { name, width }) => {
      agg[name] = width;
      return agg;
    }, {});
    this.on = pubsub.on;
    this.off = pubsub.off;

    const flags = breakpoints.reduce((agg, { name, width }) => {
      this.addXAndUp(name, width, agg);
      this.addUpToX(name, width, agg);
      return agg;
    }, {});
    Object.keys(flags).forEach((key) => {
      this[key] = flags[key];
    });
  }

  addAndWatchFlag(name, flagName, mediaQueryString, agg) {
    const mediaQuery = window.matchMedia(mediaQueryString);
    agg[flagName] = mediaQuery.matches;
    const listener = ({ matches }) => {
      this[flagName] = matches;
      pubsub.emit(`change:${name}`);
      emitChangeWithDebounced();
    };
    if (typeof mediaQuery.addEventListener === 'function') {
      mediaQuery.addEventListener('change', listener);
    } else {
      mediaQuery.addListener(listener);
    }
    pubsub.emit(`change:${name}`);
    emitChangeWithDebounced();
  }

  addXAndUp(name, width, agg) {
    const flagName = `${name}_and_up`;
    const mediaQueryString = `(min-width: ${width}px)`;
    this.addAndWatchFlag(name, flagName, mediaQueryString, agg);
  }

  addUpToX(name, width, agg) {
    const flagName = `up_to_${name}`;
    const mediaQueryString = `(max-width: ${width - 1}px)`;
    this.addAndWatchFlag(name, flagName, mediaQueryString, agg);
  }

  // eslint-disable-next-line class-methods-use-this
  checkIfTouchDevice() {
    return window.matchMedia('(pointer: coarse)').matches;
  }

  // eslint-disable-next-line class-methods-use-this
  prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }
}

export const mediaQuery = new MediaQuery();
